<template lang="html">
  <div text-center d-flex align-center>

    <!-- Dialog de confirmação para exclusão de um órgão financiador -->
    <c-confirm-dialog v-model="dialogConfirmaExclusao" @yes="excluirOrgaoFinanciadorProjetoPesquisa()" titulo="Deseja realmente excluir o órgão financiador?">
    </c-confirm-dialog>

    <!-- Tabela com os órgãos financiadores -->
    <v-data-table
      :headers="headers"
      :items="listaOrgaosFinanciadores"
      :search="search"
      :no-data-text="'Nenhum órgão financiador cadastrado.'"
      must-sort
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :items-per-page="itemsPerPage"
      :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template v-slot:item.opcoes="props">
        <div>

          <!-- Editar órgão financiador -->
          <c-tooltip-btn
          icon="edit"
          color="primary"
          tooltip="Editar órgão financiador"
          @click="toEditarOrgaoFinanciadorProjetoPesquisa(props.item.id)"
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
          ></c-tooltip-btn>

          <!-- Excluir órgão financiador -->
          <c-tooltip-btn
          icon="delete"
          color="primary"
          tooltip="Excluir órgão financiador"
          @click="toExcluirOrgaoFinanciadorProjetoPesquisa(props.item.id)"
          v-if="administradorPRPPG || projetoPesquisa.coordenador"
          ></c-tooltip-btn>

        </div>
      </template>

      <!-- Formata a sigla -->
      <template v-slot:item.sigla="props">{{ props.item.sigla === null || props.item.sigla === '' ? '-' : props.item.sigla }}</template>

      <!-- Formata o valor -->
      <template v-slot:item.valor="props">{{ props.item.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</template>

      <!-- Número total de órgãos financiadores -->
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaOrgaosFinanciadores.length }} {{ listaOrgaosFinanciadores.length > 1 ? 'órgãos financiadores' : 'órgão financiador' }}
      </template>

    </v-data-table>

    <br><br>

    <v-card-actions>

      <!-- Botão "Voltar" -->
      <v-btn color="primary" @click="toVoltar()">Voltar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Adicionar Órgão Financiador" -->
      <v-btn color="primary" @click="toPesquisarOrgao()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Adicionar Órgão Financiador</v-btn>

      <!-- Botão "Avançar" -->
      <v-btn color="primary" @click="toAvancar()">Avançar</v-btn>

    </v-card-actions>
    
  </div>
</template>

<script>
import projetos from '@/utils/projetos'
import ConfirmDialog from '@/components/c-confirm-dialog'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import TootipButton from '@/components/c-tooltip-btn'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
    dialogConfirmaExclusao: false,
    idOrgaoFinanciadorProjetoPesquisaExclusao: '',
    sortBy: null,
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    listaOrgaosFinanciadores: [],
    headers: [
      { text: 'Nome', align: 'left', value: 'nome' },
      { text: 'Sigla', align: 'left', value: 'sigla' },
      { text: 'Valor', align: 'left', value: 'valor' },
      { text: 'Opções', align: 'left', value: 'opcoes' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Carrega os órgãos financiadores do projeto de pesquisa.
    carregaOrgaosFinanciadoresProjetoPesquisa: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgãos financiadores...' })
      projetos.getOrgaosFinanciadoresProjetoPesquisa(this.idProjetoPesquisa)
      .then(response => {
        this.listaOrgaosFinanciadores = response.data.slice()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando órgãos financiadores...' })
      })
    },

    // Edita o órgão financiador.
    toEditarOrgaoFinanciadorProjetoPesquisa: function (idOrgaoFinanciadorProjetoPesquisa) {
      this.$router.push({ name: 'EditarProjetoPesquisaOrgaoFinanciador', params: {idProjetoPesquisa: this.idProjetoPesquisa, idOrgaoFinanciadorProjetoPesquisa: idOrgaoFinanciadorProjetoPesquisa} })
    },

    // Voltar para a aba anterior.
    toVoltar: function () {
      this.$router.push({ name: 'ProjetoPesquisaEquipe', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Avançar para a próxima aba.
    toAvancar: function () {
      this.$router.push({ name: 'ProjetoPesquisaArquivos', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Pesquisa por órgãos financiadores.
    toPesquisarOrgao: function () {
      this.$router.push({ name: 'ProjetoPesquisaPesquisarOrgaoFinanciador', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Exclui um órgão financiador (abre dialog de confirmação).
    toExcluirOrgaoFinanciadorProjetoPesquisa: function (idOrgaoFinanciadorProjetoPesquisa) {
      this.idOrgaoFinanciadorProjetoPesquisaExclusao = idOrgaoFinanciadorProjetoPesquisa
      this.dialogConfirmaExclusao = true
    },

    // Exclui um órgão financiador (chama endpoint para exclusão).
    excluirOrgaoFinanciadorProjetoPesquisa: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo órgão financiador...' })
      projetos.deleteOrgaoFinanciadorProjetoPesquisa(this.idProjetoPesquisa, this.idOrgaoFinanciadorProjetoPesquisaExclusao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.carregaOrgaosFinanciadoresProjetoPesquisa()
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Excluindo órgão financiador...' })
      })
    }
  },
  mounted () {
    this.carregaOrgaosFinanciadoresProjetoPesquisa()
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-tooltip-btn': TootipButton,
    'c-confirm-dialog': ConfirmDialog
  }
}
</script>



// WEBPACK FOOTER //
// orgaos-financiadores.vue?2f8e3340